export enum RushMode {
  NORMAL = 'normal',
  BUSY = 'busy',
  HEAVY_RUSH = 'heavy_rush',
}

/** Default prep-time (minutes) applied when no per-order override is set. */
export const RUSH_MODE_MINUTES: Record<RushMode, number> = {
  [RushMode.NORMAL]: 10,
  [RushMode.BUSY]: 15,
  [RushMode.HEAVY_RUSH]: 25,
};

export enum OrderStatus {
  PENDING = 'pending',
  PREPARING = 'preparing',
  READY = 'ready',
  COLLECTED = 'collected',
  CANCELLED = 'cancelled',
}

export enum BatchStatus {
  OPEN = 'open',
  NOTIFIED = 'notified',
  CLOSED = 'closed',
}

export enum SubscriptionPlan {
  TRIAL = 'trial',
  BASIC = 'basic',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
}

export enum SubscriptionStatus {
  ACTIVE = 'active',
  TRIAL = 'trial',
  GRACE = 'grace',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled',
}

export enum QRStatus {
  UNLINKED = 'unlinked',
  LINKED = 'linked',
  REVOKED = 'revoked',
}

export enum NotificationStatus {
  PENDING = 'pending',
  SENT = 'sent',
  FAILED = 'failed',
  EXPIRED = 'expired',
}

export interface PlanLimit {
  ordersPerMonth: number;
  shopsAllowed: number;
  pushNotifications: boolean;
  batchNotifications: boolean;
  analytics: boolean;
}

export const PLAN_LIMITS: Record<SubscriptionPlan, PlanLimit> = {
  [SubscriptionPlan.TRIAL]: {
    ordersPerMonth: 100,
    shopsAllowed: 1,
    pushNotifications: true,
    batchNotifications: false,
    analytics: false,
  },
  [SubscriptionPlan.BASIC]: {
    ordersPerMonth: 1_000,
    shopsAllowed: 1,
    pushNotifications: true,
    batchNotifications: true,
    analytics: false,
  },
  [SubscriptionPlan.PRO]: {
    ordersPerMonth: 10_000,
    shopsAllowed: 5,
    pushNotifications: true,
    batchNotifications: true,
    analytics: true,
  },
  [SubscriptionPlan.ENTERPRISE]: {
    ordersPerMonth: Infinity,
    shopsAllowed: Infinity,
    pushNotifications: true,
    batchNotifications: true,
    analytics: true,
  },
};

// Discriminated union of all user roles in the system
export type UserRole = 'admin' | 'shop_owner';

/** Maximum notifications a shop may send per calendar day, keyed by plan. */
export const PLAN_DAILY_LIMIT: Record<SubscriptionPlan, number> = {
  [SubscriptionPlan.TRIAL]: 50,
  [SubscriptionPlan.BASIC]: 500,
  [SubscriptionPlan.PRO]: 5_000,
  [SubscriptionPlan.ENTERPRISE]: Infinity,
};

/** Days a subscription stays accessible after a failed payment before it is fully expired. */
export const SUBSCRIPTION_GRACE_PERIOD_DAYS = 3;

export const DEFAULT_PREP_TIME_MINUTES = 10;
export const MAX_PUSH_RETRY_ATTEMPTS = 3;
export const PUSH_RETRY_DELAY_MS = 5_000;
export const ORDER_EXPIRY_MINUTES = 30;
export const RUSH_MODE_MULTIPLIER = 0.6; // 40% faster prep time in rush mode
